module.exports = __webpack_public_path__ + "static/media/avanti.b615835d.jpg";